/*global _ */
import {name, mixins, props, data, EventBus} from './config'

export default {
  name,
  props,
  mixins,

  data() {
    return {
      ...data,
      isSubmitting: false,
      termsAgreed: 'no',
      editMode: false,
      editItem: null,
      cardsList: [],
    }
  },

  computed: {
    showBonus() {
      return this.showBonusBox && this.playcardProduct && this.playcardQuantity
    },
    bonus() {
      return this.playcardProduct.balance.bonus_cash * this.playcardQuantity
    },
  },

  created() {
    if (!_.isEmpty(this.products)) {
      this.cardsList = this.products
    } else {
      this.playcardProducts = this.getProducts()
      this.cardsList = this.playcardProducts
    }
    this.playcardQuantity = 1

    this.editMode = !!this.token || !!this.item

    if (this.editMode) {
      this.termsAgreed = 'yes'
      this.editItem = this.currentCartItems[this.token || this.item]
    }

    EventBus.$on('buy-card.change.productId', productId => {
      this.playcardProductId = productId
    })
    EventBus.$on('buy-card.change.quantity', quantity => {
      //this.playcardQuantity = quantity
    })

    EventBus.$on('buy-card.add-to-cart', data => {
      const item = this.getPlaycardCartItem(data)

      this.isSubmitting = true

      if (this.editMode) {
        this.updateCartItem(item)
      } else {
        this.addCartItem(item)
      }
      EventBus.$emit('buy.playcard.add-to-cart')
    })
  },
  methods: {
    getProducts() {
      let products = window.addiesaas.products.types[this.productType]
      products = _.omitBy(products, p => {
        return !!(1 * _.get(p, 'custom.skip-regular'))
      })
      return products
    },
    getPlaycardCartItem(data) {
      const product = data.product
      let item = this.editMode ? this.editItem : {
        type: product.type || this.productType || 'playcard_sale',
        editRoute: {name: 'playcards.buy'}
      }

      item = _.merge({}, item, {
        editable: this.cartItemEditable,
        total: data.product.price * data.quantity,
        count: data.quantity,
        payload: {
          product_id: data.product.id,
          count: data.quantity,
        },
        attributes: {
          product: data.product,
        },
      })

      return item
    }
  }
}
